import React, { useState } from 'react';
import { LiveDashboard } from '../../pages/Home/LiveDashboard';
import { VicuTabBar } from './VicuTabBar'; // Adjust the import path as necessary
import { Device } from "../../interfaces/Device";
import { VICU } from "../../interfaces/VICU";
import { useTranslation } from "react-i18next";
import { MapView } from "../../pages/Home/MapView/MapView";
import CustomTabs from "../tabs/CustomTabs";
import { MissionCentral } from '../../pages/Home/MissionCentral';

interface EMSDashboardTabsProps {
    visibleDevices: Device[];
    monitorGroupList: VICU[];
    setSelectedVICU: (vicu: VICU | null) => void;
    selectedVICU: VICU | null;
    updateDeviceList: () => void;
    setDevices: (devices: Device[]) => void;
    useSyspool: boolean;
    organization_id: string;

    clinicOptions: { value: string; label: string }[]; // Add the dropdownOptions prop
    clinicDropdownTitle: string;
    selectedClinicItem: string | undefined;
    onClinicChange: (value: string) => void; // Add this prop

    filterOptions: { value: number; label: string }[]; // Add the dropdownOptions prop
    filterDropdownTitle: string;
    selectedFilterItem: number | undefined;
    onFilterChange: (value: number) => void; // Add this prop


}

const EMSDashboardTabs: React.FC<EMSDashboardTabsProps> = ({
    organization_id,
    visibleDevices,
    monitorGroupList,
    setSelectedVICU,
    selectedVICU,
    updateDeviceList,
    setDevices,
    useSyspool,
    clinicOptions,
    onClinicChange,
    clinicDropdownTitle,
    selectedClinicItem,

    filterOptions,
    onFilterChange,
    filterDropdownTitle,
    selectedFilterItem


}) => {
    const { t } = useTranslation();
    const [currentTab, setCurrentTab] = useState<number>(0);
    const [selectedClinic, setSelectedClinic] = useState<string>(
        selectedClinicItem || (clinicOptions.length > 0 ? clinicOptions[0].value : '')
    );
    const [selectedFilter, setSelectedFilter] = useState<number>(selectedFilterItem || 0);
    const tabNames = [
        t("mission_central"),
        t("live_dashboard"),
        t("mapview")
    ];

    const tabComponents = [
        <MissionCentral organization_id={organization_id} devicelist={visibleDevices} filterValue={selectedFilter}>
            <VicuTabBar
                vicuList={monitorGroupList?.filter((item: any) => item.group_name !== "syspool")}
                activateVicu={setSelectedVICU}
                activeVicu={selectedVICU}
                refreshDevices={updateDeviceList}
            />
        </MissionCentral>,

        <LiveDashboard devicelist={visibleDevices} organization_id={organization_id} filterValue={selectedFilter}>
            <VicuTabBar
                vicuList={monitorGroupList?.filter((item: any) => item.group_name !== "syspool")}
                activateVicu={setSelectedVICU}
                activeVicu={selectedVICU}
                refreshDevices={updateDeviceList}
                
            />
        </LiveDashboard>,

        <MapView devices={visibleDevices} setDevices={setDevices} organization_id={organization_id} filterValue={selectedFilter} >
            <VicuTabBar
                vicuList={monitorGroupList?.filter((item: any) => item.group_name !== "syspool")}
                activateVicu={setSelectedVICU}
                activeVicu={selectedVICU}
                refreshDevices={updateDeviceList}
            />
        </MapView>
    ];

    const handleClinicChange = (value: string) => {
        setSelectedClinic(value);
        onClinicChange(value);
    };

    const handleFilterChange = (value: string) => {
        setSelectedFilter(Number (value));
        onFilterChange(Number (value));
    };


    return (
        <div>
            <CustomTabs
                tabNames={tabNames}
                tabComponents={tabComponents}
                value={currentTab}
                onTabChange={setCurrentTab}

                clinicOptions={clinicOptions} // Pass dropdownOptions to CustomTabs
                selectedClinic={selectedClinic}
                onClinicChange={handleClinicChange}
                clinicDropdownTitle={clinicDropdownTitle}

                filterOptions={filterOptions} // Pass dropdownOptions to CustomTabs
                selectedFilter={'' + selectedFilter}
                onFilterChange={handleFilterChange}
                filterDropdownTitle={filterDropdownTitle}

            />


        </div>
    );
};

export default EMSDashboardTabs;
